module.exports = __webpack_public_path__ + "static/img/72949232_p0_master1200.8df0d65.jpg";